<template>
    <CompassDialog
        :visible.sync="showModal"
        size="small"
        :title="getTitle"
        class="deactivate-2fa"
        @closed="close"
    >
        <template slot="default">
            <div class="dialog__default">
                <template v-if="provider">
                    <ProviderLabel2FA :provider="provider" />

                    <template v-if="provider.primary">
                        <p class="semibold m-0 mb-2">
                            {{
                                $l10n.__(
                                    "En désactivant votre méthode d'authentification principale, vous ne recevrez plus de code de sécurité sur celle-ci.",
                                )
                            }}
                        </p>
                        <p class="m-0 mb-3">
                            {{
                                $l10n.__(
                                    "Si vous n'avez pas défini de méthode d'authentification secondaire, la double authentification sera désactivée sur votre compte.",
                                )
                            }}
                        </p>

                        <div v-if="requiredFromCorp" class="alert alert-danger m-0 flex-row">
                            <div class="no-shrink mr-2">
                                <CompassIcon type="alert" icon="alert-circle-fill" />
                            </div>
                            <div>
                                <p>
                                    {{
                                        $l10n.__(
                                            "La double authentification a été rendue obligatoire par l'administrateur de votre société.",
                                        )
                                    }}
                                </p>
                                <p>
                                    {{
                                        $l10n.__(
                                            "En continuant, vous allez être déconnecté de votre compte. Reconnectez-vous pour configurer la double authentification avec une nouvelle méthode d'authentification.",
                                        )
                                    }}
                                </p>
                            </div>
                        </div>
                    </template>

                    <template v-else>
                        <p class="semibold m-0 mb-2">
                            {{
                                $l10n.__(
                                    "En désactivant votre méthode d'authentification secondaire, vous ne recevrez plus de code de sécurité sur celle-ci.",
                                )
                            }}
                        </p>
                        <p class="m-0 mb-3">
                            {{
                                $l10n.__(
                                    "La sécurité de votre compte reste renforcée. Vous recevrez les codes de sécurité sur votre méthode d'authentification principale.",
                                )
                            }}
                        </p>
                    </template>
                </template>

                <template v-else>
                    <p class="semibold m-0 mb-2">
                        {{
                            $l10n.__(
                                'En désactivant la double authentification, la sécurité de votre compte ne sera plus renforcée.',
                            )
                        }}
                    </p>
                    <p class="m-0 mb-3">
                        {{
                            $l10n.__(
                                'Vous ne recevrez plus aucun code de sécurité si nous remarquons une tentative de connexion depuis un appareil non reconnu.',
                            )
                        }}
                    </p>
                </template>
            </div>
        </template>
        <template slot="footer">
            <div class="dialog__footer">
                <CompassButton
                    :label="$t.__('common.actions.cancel')"
                    type="secondary"
                    @click="close"
                />
                <CompassButton
                    :label="
                        provider
                            ? $t.__('common.actions.disable')
                            : $t.__('popups.Deactivate2FA.disable_dual_authentication')
                    "
                    :type="isSecondary ? 'primary' : 'primary-destructive'"
                    :loading="loading"
                    class="ml-3"
                    @click="save()"
                />
            </div>
        </template>
    </CompassDialog>
</template>

<script>
import ProviderLabel2FA from 'vcomponents/ProviderLabel2FA/ProviderLabel2FA.vue';
export default {
    components: {
        ProviderLabel2FA,
    },
    props: {
        provider: {
            type: Object | null,
        },
        providers: {
            type: Array,
            required: false,
            default: [],
        },
        requiredFromCorp: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            showModal: true,
            loading: false,
        };
    },
    computed: {
        getTitle() {
            if (!this.provider) {
                return this.$l10n.__('Désactiver ma double authentification');
            } else {
                return this.provider.primary
                    ? this.$l10n.__("Désactiver ma méthode d'authentification principale")
                    : this.$l10n.__("Désactiver ma méthode d'authentification secondaire");
            }
        },
        isSecondary() {
            return this.provider && !this.provider.primary;
        },
    },
    methods: {
        save() {
            this.loading = true;
            const config = {};
            if (this.provider) {
                config.providers = this.providers.filter(
                    (item) => item.provider !== this.provider.provider,
                );
            } else {
                config.providers = [];
            }

            ApiClient.put('/settings/two-factor-authentication/user', {}, config)
                .then(() => {
                    if (this.requiredFromCorp && this.provider?.primary) {
                        window.location.href = '/logout';
                    } else {
                        this.$trigger('2fa:updateUserSettings');
                        Push.success(this.$l10n.__('Double authentification désactivée'));
                    }
                })
                .catch(() => {
                    Push.error(this.$l10n.__('Une erreur est survenue'));
                })
                .finally(() => {
                    this.close();
                });
        },
        close() {
            this.$emit('close');
            this.$trigger('2fa:closeDeactivationPopup');
        },
    },
};
</script>

<style lang="scss" scoped>
.deactivate-2fa {
    .dialog {
        &__default {
            padding-bottom: 24px;
        }

        &__footer {
            display: flex;
            justify-content: flex-end;
            padding: 0 32px 24px 32px;
        }
    }

    .alert {
        font-weight: 400;
        padding: 10px 16px;
    }
}
</style>
